module.exports = __webpack_public_path__ + "img/unlocked.befe03df.svg";